import React, { Component } from "react"

import {
  HeadingInitial,
  HeadingSecondary,
  Paragraph,
  Section,
  Tagline,
  List,
  ListItem,
} from "elements"

class Feature extends Component {
  render() {
    return (
      <div>
        <HeadingInitial>Features for Camps</HeadingInitial>

        <Section>
          <Tagline>
            Camps and Campers offers an efficient, economical method of
            locating, evaluating, and contacting potential campers.
          </Tagline>
          <Paragraph>
            With Camps and Campers, you will be posting your camp profile and
            specific openings where the right people will see them. Potential
            campers will send their information to you via email in our
            carefully constructed profile format. We also offer you a quick and
            easy way to search for qualified camp leads on our website. What's
            more, member camps have access to our revolutionary Direct Email
            feature, which takes promoting openings to a whole new level.
          </Paragraph>
        </Section>

        <Section>
          <HeadingSecondary>You Find Campers</HeadingSecondary>
          <Paragraph>
            We find out quite a bit about camp families. This information is
            made available to you through a simple on-line search interface, and
            when campers contact you via email.
          </Paragraph>
          <Paragraph>
            Use our powerful search feature to search across multiple categories
            (e.g. show me all families with 10 year old girls seeking a co-ed
            camp in New England). Add keywords to be even more specific about
            the interests of campers.
          </Paragraph>
          <Paragraph>
            Search results give you a quick look at family profiles. Following
            links leads to full profiles with detailed information about
            potential campers.
          </Paragraph>
        </Section>

        <Section>
          <HeadingSecondary>Camp Families Find You</HeadingSecondary>
          <Paragraph>
            Camp families can search all the data that camps provide us via our
            search form. We allow unprecedented flexibility in how families look
            for camps, while keeping the process fast and simple. The result is
            that your camp will be found by the right people!
          </Paragraph>
          <Paragraph>
            After conducting a search, camp names turn up as live links. In
            addition to what they already know about you, registered camp
            families can follow these links to find an attractive webpage
            dedicated to your camp. We build this out of the information from
            your registration form, so it includes a description of your camp, a
            list of available positions, and contact information.
          </Paragraph>
        </Section>

        {/*should be side box*/}
        <Section>
          <HeadingSecondary>Key Features</HeadingSecondary>

          <List>
            <ListItem>
              Find New Campers Access to a database of families seeking camps
            </ListItem>
            <ListItem>
              Easy, Customized Searching Search for campers that match your
              openings and link to an family’s profile with one easy click
            </ListItem>
            <ListItem>
              Organization Tools Save and categorize leads for easy reference
            </ListItem>
            <ListItem>
              Link to Your Own Site Advertise directly to hundreds of qualified
              leads via your camp’s information page with a link to your camp
              website!
            </ListItem>
            <ListItem>
              Families Find You Receive profiles of qualified campers via email,
              as they seek you out
            </ListItem>
          </List>
        </Section>
      </div>
    )
  }
}

export default Feature



// WEBPACK FOOTER //
// ./src/scenes/About/pages/features.js